import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

import config from '../config/config';
import { useAuth } from '../contexts/AuthContext';
import { setFlashMessage, useWebsite } from '../contexts/WebsiteContext';

const UserParameters = () => {
    const { t } = useTranslation();
    const [editedUser, setEditedUser] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const { token } = useAuth();
    const { setIsLoading } = useWebsite();

    useEffect(() => {
        if (token) {
            async function fetchUserData() {
                try {
                    setIsLoading(true);
                    const response = await axios.get(`${config.apiUrl}user/me`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
                    setEditedUser(response.data);
                } catch (error) {
                    console.error('Error fetching user data:', error);
                }
                setIsLoading(false);
            }
            fetchUserData();
        }
    }, [token, setIsLoading]);

    const handleEditInputChange = (e) => {
        const { name, value } = e.target;
        setEditedUser(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleEditSubmit = async () => {
        try {
            setIsLoading(true);
            await axios.put(`${config.apiUrl}user/me`, editedUser, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            handleCloseEditModal();
            setFlashMessage(t('SUCCESS_UPDATED_MESSAGE'), 'success');
        } catch (error) {
            setFlashMessage(t('ERROR_MESSAGE'), 'error');
            console.error('Error updating user:', error);
        }
        setIsLoading(false);
    };

    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleCloseEditModal = () => {
        setShowModal(false);
    };

    return (
        <>
            <h2>Vous</h2>
            <div className="kubuni-frame">
                {editedUser && (
                    <>
                        <p><strong>Nom:</strong> {editedUser.lastname}</p>
                        <p><strong>Prénom:</strong> {editedUser.firstname}</p>
                        <p><strong>Téléphone:</strong> {editedUser.phone}</p>
                    </>
                )}
                <Button variant="primary" onClick={handleShowModal} style={{ margin: '20px' }}>
                    Mettre à jour
                </Button>
            </div>

            <div className="short-line"></div>

            <Modal show={showModal} onHide={handleCloseEditModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Mettre à jour</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Votre nom</Form.Label>
                            <Form.Control
                                type="text"
                                name="lastname"
                                value={editedUser ? editedUser.lastname : ''}
                                onChange={handleEditInputChange}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Votre prénom</Form.Label>
                            <Form.Control
                                type="text"
                                name="firstname"
                                value={editedUser ? editedUser.firstname : ''}
                                onChange={handleEditInputChange}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Votre numéro de téléphone</Form.Label>
                            <Form.Control
                                type="text"
                                name="phone"
                                value={editedUser ? editedUser.phone : ''}
                                onChange={handleEditInputChange}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <Button variant="secondary" onClick={handleCloseEditModal}>
                        {t('CANCEL')}
                    </Button>
                    <Button variant="primary" onClick={handleEditSubmit}>
                        {t('CONFIRM')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default UserParameters;
